export default __webpack_public_path__ + "static/media/KGA_Login_logo.d4a3bc36.png";